// extracted by mini-css-extract-plugin
export default {"heading":"_2I5A","description":"_3510","info":"_3qtu"};